import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'app-dialog-content',
    templateUrl: './dialog-content.component.html',
    styleUrls: ['./dialog-content.component.scss'],
    standalone: true,
    imports: [TranslocoModule, CommonModule, MatDialogModule]
})
export class DialogContentComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
